import { render, staticRenderFns } from "./UploadBanner.vue?vue&type=template&id=6170bdee&"
import script from "./UploadBanner.vue?vue&type=script&lang=js&"
export * from "./UploadBanner.vue?vue&type=script&lang=js&"
import style0 from "./UploadBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports